export default "706e7df7d542525f.svg"